<template>
  <div id="app">   
      <div v-if="activityflag">
            <div class="top-banner" v-if="activityImg">
                <img :src="activityImg" alt="">
            </div>
            <div class="list_content" :class="{'open-t30':activityImg}">
                <div class="item"  :class="{openitem:isOpen && openIndex == index}" v-for="(item, index) in cardList" :key="item.brandId" @click="openCardPpage(index)">
                    <img :src="item.cardUrl" alt="" class="item_img"/>
                    <div class="item_content">
                        <div class="item_content_top">
                            <img :src="item.cardLogo" alt="" class="logo_img"/>
                            <div class="logo_text">
                                <p class="t1">{{item.cardName}}</p>
                            
                            </div>
                            <span class="logo_identy t0">{{item.customerLevelName}}</span>
                        </div>
                        
                    </div>
                </div>
                <div class="item_4"></div>
            </div>

            <!-- 开通验证会员 -->
            <div class="open_content" :class="{'open-mt30':activityImg}" v-if="!allMember">             
                <p class="t5 textcenter">已开通 <span style="color: #F2270C;">{{memberNum}}</span> 个品牌会员</p>
                <p class="t1">我的信息</p>
                <div class="t5 info_item">
                    <span class="item_1"><i style="color: #F2270C;">*</i>&nbsp;手机号码</span>
                    <input type="tel" v-model="form.startiphonenumber" class="input" disabled="true" v-show="form.oldiphonenumber && !showCode"/>
                    <input type="tel" v-model="form.iphonenumber" class="input" placeholder="请输入手机号" @change="chengeIpnoneNumber" v-show="showCode"/>
                    <span class="blue" @click="sendSafeCode" v-show="showCode && !showTimeBlock">发送验证码</span>
                    <span class="blue" v-show="showTimeBlock">{{count}}s</span>
                    <span class="blue" @click="editIpnoneNumber" v-show="!showCode"><i class="bg_pen"></i></span>
                </div>
                <div >
                        <div class="t5 info_item" v-show="showCode">
                            <span class="item_1"><i style="color: #F2270C;">*</i>&nbsp;验证码</span>
                            <input type="text" v-model="form.smsCode" class="input" placeholder="请输入验证码"/>
                        </div>
                </div>
                
                <div class="agree_content">
                    <div class="radio" :class="{selected:radioButton}" @click="selectRadio"> </div>
                    <div class="t0 gray">
                    确认授权即同意
                    <router-link class="blue" tag="a" target="_blank" :to="{name:'agreeMentCard'}">《京东平台授权声明》</router-link>
                    及
                    <router-link class="blue" tag="a" target="_blank" v-for="(item,index) in cardList" :key="index" :to="{name:'agreeMentCard', query:{id:item.brandId}}">《{{item.cardName}}授权协议》</router-link>
                    并将个人信息授权品牌
                    </div>
                </div>           
            </div>
            <!-- 已开通所有会员 -->
            <div class="open_content" :class="{'open-mt30':activityImg}" v-else>
                <p class="t1 textcenter" style="margin-bottom:15px;">恭喜您已集齐所有会员卡</p> 
                <div class="open_button t5 whit" :class="{opa:opaBtn}" @click="toLink">进入联合活动</div> 
            </div>
            <div class="fix_bottom" v-if="!allMember">
                <div class="open_button t5 J_ping" :class="{opa:!radioButton}" @click="openCardButton" v-show="!showLoading" report-eventid="Unionbind_bind">确认授权并加入店铺会员</div>   
                <div class="open_button t5" v-show="showLoading"><i class="loading_icon"></i>拼命加载中...</div>   
            </div>
            <!-- 入会享好礼 -->
            <!-- <div class="quan-content" v-if="showCoupon && showCoupon!='HIDE'"> -->
            <div class="quan-content" id="quan" v-if="unionGiftList && unionGiftList.length > 0">
                <p class="quan-title">入会享好礼</p>
                <div class="quan-box" :class="{ 'gray': item.couponStatusEnum == 'NO_STOCK' }" v-for="(item, index) in unionGiftList" :key="index">
                    <div class="quan-left">
                        <p class="quan-price">￥<span>{{item.discount}}</span></p>
                        <p class="quan-limit">满{{item.quota}}元可用</p>
                    </div>
                    <div class="quan-right">
                        <p class="quan-text" :class="{'gray-text': item.couponStatusEnum == 'NO_STOCK'}">
                            <span class="quan-logo" :class="{'gray-back': item.couponStatusEnum == 'NO_STOCK' }" v-if="item.couponType == 1">东券</span>
                            <span class="quan-logo" :class="{'gray-back': item.couponStatusEnum == 'NO_STOCK' }" v-if="item.couponType == 0">京券</span>
                            {{item.couponName}}
                        </p>
                        <div class="quan-time">
                            {{item.beginTime}}-{{item.endTime}}
                            <span class="quan-btns J_ping" v-if="item.couponStatusEnum == 'RECEIVED'" report-eventid="Unionbind_usecoupon" @click="useQuan(item)">去使用</span>
                            <span class="quan-btns J_ping" v-if="item.couponStatusEnum == 'AVAILABLE'" report-eventid="Unionbind_getcoupon" @click="sendQuan(item)">立即领取</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ad_content" id="banner" v-if="rotationInfos && rotationInfos.length > 0">
                <div class="ad_title">
                    <span class="ad_icon">—</span>
                    <i></i>
                    <span class="t5">联合权益</span>
                    <span class="ad_icon">—</span>             
                </div>
                <wd-swipe>
                    <wd-swipe-item v-for="(item,index) in rotationInfos" :key="index">
                        <a :href="item.rightsUrl" class="J_ping" :report-eventid="`Unionbind_banner${index+1}`"><img :src="item.rightsImageRul" alt="" class="ad_img"></a>              
                    </wd-swipe-item>
                </wd-swipe>
            </div>
      </div>

        <div  class="error" v-else>
            <div class="error_content">
                <img src="@/assets/img/default_logo.png" alt="">
                <p class="t6">{{textPage}}</p>
            </div>
        </div>
        <div class="coupon_tip" v-show="showFlag">{{tostMes}}</div>
        <a class="target" href="" target="_blank"></a>
        <div  class="error pageloading" v-show="pageLoading">
        <div class="error_content">
            <img src="@/assets/img/loading.png"  class="img_loading" alt="">
            <p class="t6">页面正在努力加载中...</p>
        </div>
    </div>
      
  </div>

</template>


<script>
import moment from 'moment'
export default {
  name: 'openCard',
  components: {
  },
  data () {
    return {
        activityImg:'',
        unionGiftList:[],
        base_port:'//crmsam.jd.com/union',
        coupon_port:'//crmsam.jd.com/',
        form:{
            oldiphonenumber:null, //备份手机号
            iphonenumber:null,  // 明文手机号
            startiphonenumber:null, //加密手机号
            smsCode:null,
            brandIds:[],
            failbrandIds:[],
        },
        cardList:[], //卡片列表     
        activityflag:true,  //
        showFlag:false, //tost弹窗
        tostMes:'', //tost文案
        memberNum:0, //已开通会员卡数目
        rightsUrl:'', //权益跳转链接
        rightsImageRul:'', //权益图片链接
        isOpen:false, //是否展开卡片
        openIndex:null, //展开第几张卡片
        textPage:'', //兜底页文案
        showLoading:false,
        pageLoading:true,
        showCode:false,
        showTimeBlock:false,
        count:60,
        radioButton:true,
        allMember:false,
        showCoupon:"",
        quanContent:{},
        beginTime:"",
        endTime:"",
        opaBtn:false,
        brandId:"",
        activityKey:"",
        isGiftActivity:false,  //是否有开卡有礼活动
        giftActivityToast:'',  //开卡有礼提示文案
        rotationInfos:'',  //轮播图
    }
  },
    mounted () {
        let flag = this.researchLogin()
        flag.then(v => {
            this.researchActitvityStatus()
            this.hasUrl()
            this.getGiftActivity()

        }).catch(()=>{
            this.toLoginPage()
    })
  },    
  methods:{
    IntersectionObserver(){  //模块曝光
    // 初始化监听器
        const observer = new IntersectionObserver(
            // 设置监听器回调
            entries => entries.forEach(item=>{
                // DOM如果没有进入viewport不管它
                if(item.intersectionRatio <=0) return
                // 如果DOM进入viewpoet中了，拿到它的id
                switch(item.target.id){
                    // 根据id匹配上报的字段
                    case 'quan':expLogJSON ('Unionbind_excoupon', 'crm_userMarketing');break;
                    case 'banner':expLogJSON ('Unionbind_exbanner', 'crm_userMarketing');break;
                }
                // 上报完取消监听次DOM
                observer.unobserve(item.target)
            })
        );
        // 遍历DOM进行监听
        [
            document.querySelector('#quan'),
            document.querySelector('#banner')
        ].filter(v=>v)
        .forEach(element=>observer.observe(element))
    },
    getGiftActivity(){  //判断是否有礼包活动
        let params = {
                "activityId":this.getQueryVariable("activityId")?this.getQueryVariable("activityId"):"",
                "token":this.getQueryVariable("token")?this.getQueryVariable("token"):""
            }
            let url = this.base_port + '/getGiftActivity';
            this.$axios.post(url, params)
            .then(res => {
                if(res.data.code == 200){
                    this.isGiftActivity = res.data.data;
                }
            })
    },  
    getQuanInfo(){  //获取券信息
        let params = {
            "activityId":this.getQueryVariable("activityId")?this.getQueryVariable("activityId"):"",
            "token":this.getQueryVariable("token")?this.getQueryVariable("token"):""
        }
        let url = this.base_port + '/queryUnionGiftList';
        this.$axios.get(url, {params})
        .then(res => {
            if(res.data.code == 200){
                this.unionGiftList = res.data.data
                requestAnimationFrame(()=>this.IntersectionObserver())
            }
            
        })
    },
    researchLogin(){
        return new Promise((resolve, reject)=>{
            let url = this.base_port + '/isLogin'
            this.$axios.get(url)
            .then(res => {
                if(res.data.code == 200){   
                    if(res.data.data.isLogin){
                        resolve(res.data.data.isLogin)
                    }else{
                        reject()
                    }
                }else{
                    reject()
                }
            })
        })       
    },
    toLoginPage(){
        let url = this.getQueryVariable('url');
        let activityId= this.getQueryVariable("activityId")?this.getQueryVariable("activityId"):"";
        let tokenId = this.getQueryVariable("token")?this.getQueryVariable("token"):"";

        let backUrl = encodeURIComponent(url + '&activityId=' + activityId + '&token=' + tokenId);
        let returnUrl = encodeURIComponent('https://crmsam.jd.com/union/index.html?url=');
        let loginUrl = 'https://plogin.m.jd.com/user/login.action?appid=372&returnurl='+ returnUrl + backUrl;
        location.href= loginUrl
    },
    toLink(){
        if(!this.opaBtn){  //有跳转地址，按钮不是灰色
            this.toLinkActivity();
        }else{ //没有跳转地址，按钮是灰色的
            return
        }
    },
    toLinkActivity(){
        let flag = this.researchLogin()
        flag.then(v => {
            let isUrl =  this.getQueryVariable('url');
            if(isUrl && isUrl!=""){  //有回调地址
                const urlCode = this.getQueryVariable('url').trim()
                let url = decodeURIComponent(urlCode)
                this.opaBtn = false
                location.href = url;
            }else{
                this.opaBtn = true
                this.getCardList();
            }
        }).catch(()=>{
            this.toLoginPage()
        })   
               
    },
    hasUrl(){
        let isUrl =  this.getQueryVariable('url');
        if(isUrl && isUrl!=""){  //有回调地址
            this.opaBtn = false
        }else{   //没有回调地址
            this.opaBtn = true
        }
    },
    researchActitvityStatus(){ // 查询活动状态
        let url = this.base_port + '/getActivityStatus';
        this.$axios.get(url)
        .then(res => {
            if(res.data.code == 200){
                if(res.data.data.activityStatus == 1){
                    this.activityflag = true;
                    this.getCardList()
                    this.getgetUnionRightImg()
                }else{
                    this.activityflag = false;
                    if(res.data.data.activityStatus == 3){
                        this.textPage = '活动太火爆，请稍后重试'
                    }else{
                        this.textPage = '您来晚了，活动已结束了哦'
                    }
                }
                    
            }else{
                return
            }
        })
    }, 
    chengeIpnoneNumber() {
        
        if(this.form.iphonenumber == this.form.oldiphonenumber){
            this.showTip('重新编辑的手机号码不能和上次相同')
            return false
        }

        if(!this.form.iphonenumber || !/^1\d{10}$/.test(this.form.iphonenumber)){
            this.showTip('请输入11位有效手机号码')
            return false
        }

        if(this.form.iphonenumber != this.form.oldiphonenumber){  
            this.showCode = true;        
        }        
    },
    editIpnoneNumber() {  //点击编辑手机号码
        this.form.iphonenumber = null;
        this.showCode = true;
    },
    selectRadio() {
        this.radioButton = !this.radioButton;
    },
    isBindPhoneNumber(){ // 判断用户是否绑定手机号
        let url = this.base_port + '/bindingPhoneNumber';
        this.$axios.get(url)
        .then(res => {
            if(res.data.code == 200){
                if(res.data.data){                     
                    this.form.oldiphonenumber =  res.data.data; 
                    this.form.iphonenumber = res.data.data;
                    this.form.startiphonenumber = this.form.iphonenumber.substr(0, 3) + '****' + this.form.iphonenumber.substr(7); 
                }else{
                    this.showCode = true;
                }                   
            }else{
                this.showTip(res.data.message)
            }
        })
    },
    sendSafeCode(){ // 发送验证码
        if(!this.form.iphonenumber || !/^1\d{10}$/.test(this.form.iphonenumber)){
            this.showTip('请输入11位有效手机号码')
            return false
        }
        if(this.form.iphonenumber === this.form.oldiphonenumber){
            this.showTip('重新编辑的手机号码不能和上次相同')
            return false
        }
        this.timeReduce()
       
        let json = {
            brandIds:this.form.brandIds,
            mobile:this.form.iphonenumber
        }

        let url = this.base_port + '/sendVerificationCode';
        this.$axios.post(url, json)
        .then(res => {
            if(res.data.code == 200){
                this.showTip('发送成功')       
            }else{
                this.showTip(res.data.message)
                this.showTimeBlock = false;  //重新发送
            }
        })
    },  
    getCardList(){//查询卡素材
        let activityId = this.getQueryVariable('activityId')?this.getQueryVariable('activityId'):"";
        let token = this.getQueryVariable('token')?this.getQueryVariable('token'):"";
        let url = this.base_port + '/getCardMaterial?activityId='+activityId+'&token='+token;
        this.$axios.get(url)
        .then(res => {
            this.pageLoading = false;
            if(res.data.code == 200){
                if(res.data.data !=null && res.data.data.length > 0){
                    this.cardList = []; //重置
                    this.memberNum = 0; //重置
                    this.form.failbrandIds = [];//重置
                    this.cardList = res.data.data; 
                    this.brandId = this.cardList[0].brandId;
                    this.cardList.forEach(item => { 
                        this.form.brandIds.push(item.brandId);
                        if(item.isMember){
                            this.memberNum++ //计算开通数量
                        }
                        if(!item.isMember){
                            this.form.failbrandIds.push(item.brandId)
                        }
                    })

                    if(this.memberNum < res.data.data.length){
                        this.isBindPhoneNumber()
                    }
                    //查询券信息，根据couponStatusEnum值判断券的状态（已领取还是未领取还是隐藏）
                    this.getQuanInfo()

                    //判断是否全是会员
                    this.allMember = res.data.data.every((item)=>{
                        return item.isMember == true
                    })

                }                                          
            }else{
                this.showTip(res.data.message)
            }
        })
    },
    getgetUnionRightImg(){//查询联合权益
        let token = this.getQueryVariable("token")?this.getQueryVariable("token"):"";
        let activityId = this.getQueryVariable("activityId")?this.getQueryVariable("activityId"):"";
        let url = this.base_port + '/getUnionRight?activityId=' + activityId +'&token='+ token;
        this.$axios.get(url)
        .then(res => {
            if(res.data.code == 200){
                this.rightsUrl  = res.data.data.rightsUrl;
                this.rightsImageRul = res.data.data.rightsImageRul;
                this.activityImg = res.data.data.activityImg;
                this.rotationInfos = res.data.data.rotationInfos;
            }else{
                // this.showTip(res.data.message)
            }
        })
    },
    useQuan(list){  //使用券
        if(list.couponKind == 2){  //店铺券
            location.href= `https://shop.m.jd.com/?shopId=${list.shopId}` 
        }else{  //商品券
            location.href= `https://so.m.jd.com/list/couponSearch.action?couponbatch=${list.batchId}`
        }
    },
    sendQuan(list) {  //发券
        var venderIds = this.cardList.map(function(item){
            return item.brandId;
        });  //所有店铺id
        var arr = []
        if(list){ //点击单个券领取
            arr.push(list.id)
        }else{  //一键开卡
            arr = this.unionGiftList.map(function(item){  //获取所有可领券的id
                if(item.couponStatusEnum === 'AVAILABLE'){
                    return item.id;
                }
            });
        }
        let params = { //发券接口入参
            activityId:this.getQueryVariable("activityId")?this.getQueryVariable("activityId"):null,
            token:this.getQueryVariable("token")?this.getQueryVariable("token"):"",
            prizeIds:arr,
            venderIds:venderIds
        } 
        let url = this.base_port+'/sendUnionGift';
        if(list){ //点击单个券领取
            this.$axios.post(url, params).then(res => {
                if(res.data.code == 200){
                    this.showTip('券已到账')
                    // this.showTip('会员已开通，快去使用下方优惠券吧！')
                    if(arr.length > 0){
                        this.getQuanInfo()
                        return;
                    }
                    setTimeout(()=>{
                        this.toLinkActivity()  
                    },500)
                }else{
                    this.showTip(res.data.message)
                }
            })
        }else{ //点击一键开卡，领取多张券
            if(arr.length > 0){  //有券可领
                this.$axios.post(url, params).then(res => {
                    console.log(this.isGiftActivity)
                    if(res.data.code == 200){
                        if(this.isGiftActivity){  // 有礼包
                            this.showTip(`会员已开通，快去使用下方优惠券吧！入会礼包发放中先到先得。`)
                        }else{  //无礼包
                            this.showTip('会员已开通，快去使用下方优惠券吧！')
                        }
                    }else{
                        this.showTip(res.data.message)
                    }
                    window.scrollTo(0, 520)
                    setTimeout(()=>{
                        this.toLinkActivity()  
                    },500)
                })
            }
        }
    },
    openCardButton() {  //一键开卡
        let num = this.form.iphonenumber === this.form.oldiphonenumber ? null : this.form.iphonenumber
        if(num && !this.form.smsCode){
            this.showTip('请输入验证码')
            return
        }
        if(!this.radioButton){
            return
        }        
        let flag = this.researchLogin()
        flag.then(v => {
            this.showLoading = true;
            let json = {
                phone:this.form.iphonenumber === this.form.oldiphonenumber
                        ? null : this.form.iphonenumber,//String	是	手机号，如果默认手机号没有被修改，则传null，否则传新值
                smsCode:this.form.smsCode,
                brandsIds:this.form.failbrandIds,
                bindChannel:this.getQueryVariable('activityId'),
                activityId:this.getQueryVariable("activityId")?this.getQueryVariable("activityId"):"",
                token:this.getQueryVariable("token")?this.getQueryVariable("token"):""
            }

            let url = this.base_port + '/submitBindCards';
            this.$axios.post(url, json)
            .then(res => {
                this.showLoading = false;
                if(res.data.code == 200){
                    let data = res.data.data;
                    let successflag = [],failflag = [];
                    data.forEach((item)=>{
                        if(item.code == 200){  //成功绑定了几张卡
                            successflag.push(item)
                        }else{
                            failflag.push(item)  //失败了几张卡
                        }
                    })
                    if(successflag.length === data.length){  //全部卡绑成功
                        if(this.unionGiftList && this.unionGiftList.length > 0){
                            this.sendQuan();
                        }else{   //没券可领
                            // await this.getGiftActivity()
                            if(this.isGiftActivity){  //有礼包
                                this.showTip(`会员已开通，入会礼包发放中先到先得。`)
                            }else{
                                this.showTip(`会员已开通`)
                            }
                            setTimeout(()=>{
                                this.toLinkActivity()
                            },1000)
                        }
                    }else{  //有卡绑定失败，刷新页面
                        let msg = '';
                        msg = failflag[0].brandsName + ": " + failflag[0].detail;
                        this.showTip(msg)
                        setTimeout(()=>{
                            location.reload()
                        },1000)

                    }
                }else{
                    this.showTip(res.data.message)
                    setTimeout(()=>{
                        location.reload()
                    },1000)
                }
            })
        }).catch(()=>{
            this.toLoginPage()
        }) 
        
    },
    showTip(message){       
        setTimeout(() => {
            this.showFlag = !this.showFlag;
        }, 1500)
        this.tostMes = message;
        this.showFlag = !this.showFlag;        
    },
    timeReduce(){  //倒计时
        const TIME_COUNT = 60;
        if (!this.timer) {
            this.count = TIME_COUNT;
            this.showTimeBlock = true;
            this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
            } else {
                this.showTimeBlock = false;
                clearInterval(this.timer);
                this.timer = null;
            }
            }, 1000)
        }
    },
    openCardPpage(index) {
        if(index !== this.openIndex){
            this.openIndex = index;
            this.isOpen = true;            
        }else{
            this.isOpen = !this.isOpen;
        }        
    },
    getQueryVariable(variable){
        let query = window.location.search.substring(1);
        let vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){
                return pair[1];
            }
        }
        return(false);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/openCard.scss';
</style>

